<template>
    <form @submit.prevent="saveForm()">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head flex justify-between">
                <p class="modal-card-title">
                    {{ group ? 'Update Group' : 'Add Group' }}
                </p>
            </header>
            <section class="modal-card-body">
                <d-field label="Group Name*">
                    <d-input v-model="groupForm.name" :required="true" />
                </d-field>

                <d-field label="Group Description*">
                    <d-input v-model="groupForm.description" :required="true" type="textarea" />
                </d-field>

                <d-field label="Archive Group">
                    <d-checkbox v-model="groupForm.archived">
                    </d-checkbox>
                </d-field>
            </section>
            <footer class="modal-card-foot justify-end">
                <d-btn flat @click="$parent.close()">
                    Cancel
                </d-btn>
                <d-btn :loading="saving" type="submit">
                    {{ group ? 'Update Group' : 'Add Group' }}
                </d-btn>
            </footer>
        </div>
    </form>
</template>
<script>
    import axios from 'axios';
    export default {
        props: {
            group: {
                type: Object,
                default: () => { },
            },
        },
        data: () => ({
            saving: false,
            groupForm: {
                name: '',
                description: '',
                type: 'System',
                archived: false,
            },
            groups: [],
        }),

        mounted() {
            if (this.group) {
                this.groupForm = JSON.parse(JSON.stringify(this.group));
            }
        },
        methods: {
            async saveForm() {
                this.saving = true;
                try {
                    if (this.group) {
                        await axios.patch(`/api/admin/groups/${this.groupForm.id}`, this.groupForm);
                    } else {
                        await axios.post('/api/admin/groups/', this.groupForm);
                    }
                    await this.$parent.events.getGroupsPaged();
                    this.$parent.close();
                } catch (error) {
                    this.$toast.open({ message: error.response.data[0], color: 'red-500', duration: 4000 });
                } finally {
                    this.saving = false;
                }
            },
        },
    };
</script>